import { Record } from 'immutable';

const BatchProgressRecord = Record({
  size: 0,
  started: false,
  finished: false,
  succeedCount: 0,
  failedCount: 0,
  progressCount: 0,
  progressPercentage: 0,
});

export default class BatchProgress extends BatchProgressRecord {
  static deserialize(jsonObject = {}) {
    return new BatchProgress(jsonObject);
  }
}
